/* Employees */

export const ADD_EMPLOYEE = "ADD_EMPLOYEE";
export const ADD_EMPLOYEE_SUCCESS = "ADD_EMPLOYEE_SUCCESS";
export const ADD_EMPLOYEE_ERROR = "ADD_EMPLOYEE_ERROR";

export const EDIT_EMPLOYEE = "EDIT_EMPLOYEE";
export const EDIT_EMPLOYEE_SUCCESS = "EDIT_EMPLOYEE_SUCCESS";
export const EDIT_EMPLOYEE_ERROR = "EDIT_EMPLOYEE_ERROR";

export const GET_EMPLOYEE = "GET_EMPLOYEE";
export const GET_EMPLOYEE_SUCCESS = "GET_EMPLOYEE_SUCCESS";
export const GET_EMPLOYEE_ERROR = "GET_EMPLOYEE_ERROR";

export const DELETE_EMPLOYEE = "DELETE_EMPLOYEE";
export const DELETE_EMPLOYEE_SUCCESS = "DELETE_EMPLOYEE_SUCCESS";
export const DELETE_EMPLOYEE_ERROR = "DELETE_EMPLOYEE_ERROR";

export const EMPLOYEE_ACTION_ERROR = "EMPLOYEE_ACTION_ERROR";

export const ADD_EMPLOYEE_LOG = "ADD_EMPLOYEE_LOG";

export const GET_EMPLOYEE_SUMMARY = "GET_EMPLOYEE_SUMMARY";
export const GET_EMPLOYEE_SUMMARY_SUCCESS = "GET_EMPLOYEE_SUMMARY_SUCCESS";
export const GET_EMPLOYEE_SUMMARY_ERROR = "GET_EMPLOYEE_SUMMARY_ERROR";
